import experiment from 'experiment';
import { BaseEntryScope, createEntryPoint } from '#packages/apilib';
import {
  EditorAPIKey,
  EditorCoreApiKey,
  ComponentsApiKey,
  PagesApiKey,
  WorkspaceApiKey,
} from '#packages/apis';
import { DeprecationOverlayApi, bootstrap } from './api';
import { DeprecationOverlayApiKey } from './publicApiKey';

export class DeprecationOverlayScope extends BaseEntryScope {
  editorAPI = this.useDependency(EditorAPIKey);
  editorCoreAPI = this.useDependency(EditorCoreApiKey);
  components = this.useDependency(ComponentsApiKey);
  pages = this.useDependency(PagesApiKey);
  workspace = this.useDependency(WorkspaceApiKey);
}

export const DeprecationOverlayEntryPoint = createEntryPoint({
  name: 'DeprecationOverlay',
  Scope: DeprecationOverlayScope,
  publicApi({ contributeApi }) {
    contributeApi(DeprecationOverlayApiKey, DeprecationOverlayApi);
  },
  async initialize(scope: DeprecationOverlayScope) {
    if (experiment.isOpen('se_editorDeprecationOverlay')) {
      bootstrap(scope);
    }
  },
});
